import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;
  gap: 64px;

  ${mediaQueries.tablet} {
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
  }
`
